import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import VueResource from "vue-resource";
import router from './router'

Vue.use(VueResource);

Vue.config.productionTip = false;
Vue.http.options.emulateJSON = true;

Vue.http.interceptors.push((request, next) => {
  request.headers.set("X-Saru-Public-Pass-Crude-Auth", "ooMV6MbxmZI0lCjL")
  next()
})

Vue.prototype.$api = (() => {
  if (process.env.NODE_ENV == "production") {
    return "/api";
  } else {
    return "http://10.250.150.95:5000/api";
  }
})();


new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app');
